import React, {useEffect, useState} from 'react';
import {FormikSetFieldValue} from "../../../types/CommonTypes";
import {useTranslation} from 'react-i18next';

interface Props {
    setFieldValue:FormikSetFieldValue;
    initialMonth?: string;
}

const FilterBySixMonths:React.FC<Props> = ({setFieldValue, initialMonth}) => {
    const {t} = useTranslation();
    const [months, setMonths] = useState<{ name: string; month: string }[] | null>([{month:"",name:""}]);

    const getLastSixMonths = (): { name: string; month: string }[] => {
        const formatter = new Intl.DateTimeFormat('uk', { month: 'long' });

        return Array.from({ length: 6 }, (_, i) => {
            const date = new Date();
            date.setMonth(date.getMonth() - i);
            date.setDate(1);

            return {
                name: formatter.format(date).toLowerCase(),
                month: date.toISOString().split('T')[0],
            };
        })
    };

    useEffect(() => {
        const updatedMonths = getLastSixMonths();
        setMonths(updatedMonths);
    }, []);

    // Синхронизируем значение месяца из формы
    useEffect(() => {
        if (initialMonth) {
            setFieldValue("month", initialMonth, false); // false - не валидировать
        }
    }, [initialMonth, setFieldValue]);

    // Определяем текущее значение для селекта
    const currentValue = initialMonth || months?.[0]?.month || '';

    return (
        <div className="form-filter__item form-filter__item-select2">
            <div className="item-select2__label">{t('Вибір місяця')}</div>
            <select
                name={"month"}
                className="form-filter__select2"
                value={currentValue}
                onChange={(e) => {
                    setFieldValue("month", e.target.value);
                }}
            >
                {months?.map((month, i) => (
                    <option key={i} value={month.month}>{month.name}</option>
                ))}
            </select>
        </div>
    );
};

export default FilterBySixMonths;